export class NewsletterSignup extends HTMLElement {
    constructor() {
      super()

      this.form = null
      this.input = null
      this.button = null
      this.formError = null
      this.errorLabel = null
      this.formSuccess = null
      this.isOpen = false
      this.state = 'IDLE'
      this.error = null

      this.errorMessages = {
        required: 'Please enter your email address',
        'already-signed-up': 'You are already signed up',
        'something-wrong': 'Something went wrong, please try again'
      }
    }

    connectedCallback() {
      this.form = this.querySelector('form')
      this.input = this.querySelector('input')
      this.button = this.querySelector('button')
      this.formError = this.querySelector('[data-form-error]')
      this.formSuccess = this.querySelector('[data-form-success]')
      this.errorLabel = this.formError?.querySelector('.error')

      this.form.addEventListener('submit', this.handleSubmit.bind(this))
      this.input.addEventListener('input', this.handleInput.bind(this))
    }

    animateIn() {
      this.isOpen = true
      gsap.to(this,{
        autoAlpha: 1,
        duration: .2,
        ease: 'power2.out'
      }).then(() => {
        if (this.input) {
          this.input.focus()
        }
      })
    }

    animateOut() {
      this.isOpen = false
      gsap.to(this,{
        autoAlpha: 0,
        duration: .2,
        ease: 'power2.out'
      })
    }

    setError(message) {
      this.error = message
      if (this.errorLabel) {
        this.errorLabel.textContent = this.error
        gsap.to(this.errorLabel, { autoAlpha: 1, duration: 0.2 })
      }

      this.input.classList.add('--error')
      this.form.classList.add('--error')
      this.state = 'ERROR'
    }

    setSuccess() {
      this.form.classList.add('--success')
      this.formSuccess.classList.add('--success')
      this.state = 'SUCCESS'
    }

    handleInput(e) {
      this.input.classList.remove('--error')
      this.form.classList.remove('--error')
      this.form.classList.remove('--success')
      this.formSuccess.classList.remove('--success')
      this.error = ''
      if (this.errorLabel) {
        this.errorLabel.textContent = ''
        gsap.to(this.errorLabel, { autoAlpha: 0, duration: 0.2 })
      }
    }

    async handleSubmit(event) {
      event.preventDefault()
      const email = this.input.value
      console.log(email)

      if (!email) {
        this.setError(this.errorMessages.required)
        return
      }

      // Show loading state
      this.state = 'LOADING'
      this.button.disabled = true

      const formData = new FormData()
      formData.append('email', email)
      formData.append('tag', 'Website Header')

      try {
        const response = await fetch('/wp-json/front/v1/newsletter-signup', {
          method: 'POST',
          'Content-Type': 'application/json',
          body: formData
        })

        const signup = await response.json()

        if (signup.response.code !== 200) {
          const body = JSON.parse(signup.body)
          console.log(body)
          if (body.title === 'Member Exists') {
            this.setError(this.errorMessages['already-signed-up'])
          } else if (body.title === 'Missing email') {
            this.setError(this.errorMessages.required)
          } else {
            this.setError(this.errorMessages['something-wrong'])
          }
        } else {
          // Show success state
          this.form.reset()
          this.setSuccess()
          
          // Reset after 3 seconds
          setTimeout(() => {
            this.state = 'IDLE'
            this.button.disabled = false
            this.form.classList.remove('--success')
            this.formSuccess.classList.remove('--success')
          }, 3000)
        }
      } catch (error) {
        console.log(error, signup)
        this.setError(this.errorMessages['something-wrong'])
      } finally {
        this.button.disabled = false
      }
    }
}